/*
 * Copyright (c) 2024 Amazon.com, Inc. All Rights Reserved.
 */

/**
 * @author stcatai Mar 22, 2024
 */
export enum CommitType {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  DELETE = "DELETE"
}